import { useMemo } from 'react';
import { b2bVersion } from '../utils/consts.ts';
import { useAuthStore } from '../services/store';

export const useShouldShowB2BRefreshMessage = () => {
  // Use auth store to make it reactive to token changes
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);

  return useMemo(() => {
    // Only show in B2B version
    if (!b2bVersion) {
      return false;
    }

    // If authenticated, don't show message
    if (isAuthenticated) {
      return false;
    }

    // Show message if in B2B and no token
    return true;
  }, [isAuthenticated]);
};
